import { RQGenericResponse, ResponseStatus, RQResponse } from 'types';

/**
 * Checks if the given response was successful and, if not, throws an
 * error. This should be used for APIs that follow the convention of returning
 * a status string and optional error message within their response body.
 */
export const checkResponse = (response: RQGenericResponse): void => {
  if (response.body.status === ResponseStatus.error) {
    const message: string =
      typeof response.body.message === 'object'
        ? Object.values(response.body.message).join('. ')
        : response.body.message;

    throw new Error(message);
  }
};

/**
 * Checks if the given response has a success status code and, if not, throws an
 * error. Prefer `checkResponse` over this for APIs that follow the convention
 * of returning status string and error message within their response body; this
 * function is for when you don't know what convention the API follows, if any.
 *
 * Returns the given response for promise chaining convenience.
 */
export const checkSuccess = <T = unknown>(response: RQResponse<T>): RQResponse<T> => {
  if (response.status < 200 || response.status >= 300) {
    throw new Error(`Expected 2xx status, got: ${response.status}`);
  }
  return response;
};
